import { ArrowLeftIcon } from 'components/Icons'
import moment from 'moment'

export const expandObj = (obj: any) => {
  const keys = Object.keys(obj)

  for (let i = 0; i < keys.length; ++i) {
    const key = keys[i],
      subkeys = key.split(/,\s?/),
      target = obj[key]
    delete obj[key]
    subkeys.forEach(function (key) {
      obj[key] = target
    })
  }

  return obj
}

export const filterObject = (
  obj: object,
  callback: (_val: any, _key: string) => boolean
): object => {
  return Object.fromEntries(
    Object.entries(obj).filter(([key, val]) => callback(val, key))
  )
}

export const preventDefaultOnEnter = (
  event: React.KeyboardEvent<HTMLFormElement>
) => {
  if (event.code === 'Enter') {
    event.preventDefault()
  }
}

export const downloadBase64 = (filename: string, base64: string) => {
  const fileExtension = filename.split('.').pop()

  let base64Type = ''

  if (['pdf'].includes(fileExtension)) {
    base64Type = `data:application/${fileExtension}`
  }

  if (['xlsx', 'xls'].includes(fileExtension)) {
    base64Type = `data:application/vnd.ms-excel`
  }

  if (['png', 'jpg', 'jpeg', 'gif', 'jfif'].includes(fileExtension)) {
    base64Type = `data:image/${fileExtension}`
  }

  const a = document.createElement('a')
  a.href = `${base64Type};base64,${base64}`
  a.download = `Relatorio de consulta do fornecedor.${fileExtension}`
  a.click()
}

export const openBase64InNewWindow = (filename: string, base64: string) => {
  if (/data:.*\/.*;base64,/g.test(base64)) {
    base64 = base64.replace(/data:.*\/.*;base64,/g, '')
  }
  const byteCharacters = atob(base64)
  const byteNumbers = new Array(byteCharacters.length)

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }

  const byteArray = new Uint8Array(byteNumbers)

  // Arquivos com a extensão .PDF em maisculo não caia no if e dava erro pra visualizar!
  // .toLowerCase() no final transforma qualquer .EXTENSAO em .extensao pra cair nos ifs
  const fileExtension =
    filename.split('.').pop() == 'jfif'
      ? 'jpeg'
      : filename.split('.').pop().toLowerCase()

  let base64Type = ''

  if (['pdf'].includes(fileExtension)) {
    base64Type = `application/${fileExtension};base64`
  }

  if (['xlsx'].includes(fileExtension)) {
    base64Type = `application/vnd.ms-excel;base64`
  }

  if (['png', 'jpg', 'jpeg', 'gif', 'jfif'].includes(fileExtension)) {
    base64Type = `image/${fileExtension};base64`
  }

  if (['doc', 'docx'].includes(fileExtension)) {
    base64Type = `application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64`
  }

  const file = new Blob([byteArray], { type: base64Type })
  const fileURL = URL.createObjectURL(file)

  if (['xlsx'].includes(fileExtension)) {
    const anchor = document.createElement('a')
    anchor.href = fileURL
    anchor.download = filename
    anchor.click()
    URL.revokeObjectURL(fileURL)

    return
  }
  window.open(fileURL)
}

export const convertBase64 = async (file: File) => {
  return new Promise((resolver) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(file)
    fileReader.onload = () => resolver(fileReader.result)
  })
}

export const createArrayCopy = (array: any[]): any[] =>
  JSON.parse(JSON.stringify(array))

// COM TOKEN REFRESH
export const checkHourToken = (hourLogin: Date): boolean =>
  moment(hourLogin).add(moment.duration(2, 'hours')).isBefore(moment())

// SEM TOKEN REFRESH
export const checkDayToken = (hourLogin: Date): boolean =>
  moment(hourLogin).add(moment.duration(10, 'hours')).isBefore(moment())

export function isValidCPF(cpf) {
  //https://gist.github.com/joaohcrangel/8bd48bcc40b9db63bef7201143303937
  if (typeof cpf !== 'string') return false
  cpf = cpf.replace(/[\s.-]*/gim, '')
  if (
    !cpf ||
    cpf.length != 11 ||
    cpf == '00000000000' ||
    cpf == '11111111111' ||
    cpf == '22222222222' ||
    cpf == '33333333333' ||
    cpf == '44444444444' ||
    cpf == '55555555555' ||
    cpf == '66666666666' ||
    cpf == '77777777777' ||
    cpf == '88888888888' ||
    cpf == '99999999999'
  ) {
    return false
  }
  let soma = 0
  let resto
  for (let i = 1; i <= 9; i++)
    soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i)
  resto = (soma * 10) % 11
  if (resto == 10 || resto == 11) resto = 0
  if (resto != parseInt(cpf.substring(9, 10))) return false
  soma = 0
  for (let i = 1; i <= 10; i++)
    soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i)
  resto = (soma * 10) % 11
  if (resto == 10 || resto == 11) resto = 0
  if (resto != parseInt(cpf.substring(10, 11))) return false
  return true
}

export function isValidPIS(pis) {
  if (pis === undefined) return true
  if (typeof pis !== 'string') return false
  const multiplicadorBase = '3298765432'
  let total = 0
  let resto = 0
  let multiplicando = 0
  let multiplicador = 0
  let digito = 99

  // Retira a mascara
  const numeroPIS = pis.replace(/[^\d]+/g, '')

  if (
    numeroPIS.length !== 11 ||
    numeroPIS === '00000000000' ||
    numeroPIS === '11111111111' ||
    numeroPIS === '22222222222' ||
    numeroPIS === '33333333333' ||
    numeroPIS === '44444444444' ||
    numeroPIS === '55555555555' ||
    numeroPIS === '66666666666' ||
    numeroPIS === '77777777777' ||
    numeroPIS === '88888888888' ||
    numeroPIS === '99999999999'
  ) {
    return false
  } else {
    for (let i = 0; i < 10; i++) {
      multiplicando = parseInt(numeroPIS.substring(i, i + 1))
      multiplicador = parseInt(multiplicadorBase.substring(i, i + 1))
      total += multiplicando * multiplicador
    }

    resto = 11 - (total % 11)
    resto = resto === 10 || resto === 11 ? 0 : resto

    digito = parseInt('' + numeroPIS.charAt(10))
    return resto === digito
  }
}

export function isValidCNPJ(value) {
  //https://gist.github.com/alexbruno/6623b5afa847f891de9cb6f704d86d02
  if (!value) return false

  // Aceita receber o valor como string, número ou array com todos os dígitos
  const isString = typeof value === 'string'
  const validTypes = isString || Number.isInteger(value) || Array.isArray(value)

  // Elimina valor em formato inválido
  if (!validTypes) return false

  // Filtro inicial para entradas do tipo string
  if (isString) {
    // Limita ao máximo de 18 caracteres, para CNPJ formatado
    if (value.length > 18) return false

    // Teste Regex para veificar se é uma string apenas dígitos válida
    const digitsOnly = /^\d{14}$/.test(value)
    // Teste Regex para verificar se é uma string formatada válida
    const validFormat = /^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/.test(value)

    // Se o formato é válido, usa um truque para seguir o fluxo da validação
    if (digitsOnly || validFormat) true
    // Se não, retorna inválido
    else return false
  }

  // Guarda um array com todos os dígitos do valor
  const match = value.toString().match(/\d/g)
  const numbers = Array.isArray(match) ? match.map(Number) : []

  // Valida a quantidade de dígitos
  if (numbers.length !== 14) return false

  // Elimina inválidos com todos os dígitos iguais
  const items = [...new Set(numbers)]
  if (items.length === 1) return false

  // Cálculo validador
  const calc = (x) => {
    const slice = numbers.slice(0, x)
    let factor = x - 7
    let sum = 0

    for (let i = x; i >= 1; i--) {
      const n = slice[x - i]
      sum += n * factor--
      if (factor < 2) factor = 9
    }

    const result = 11 - (sum % 11)

    return result > 9 ? 0 : result
  }

  // Separa os 2 últimos dígitos de verificadores
  const digits = numbers.slice(12)

  // Valida 1o. dígito verificador
  const digit0 = calc(12)
  if (digit0 !== digits[0]) return false

  // Valida 2o. dígito verificador
  const digit1 = calc(13)
  return digit1 === digits[1]
}

export const generateAleatoryID = (length: number): string => {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%&*-'
  const charactersLength = characters.length
  let result1 = ''

  for (let i = 0; i < length; i++) {
    result1 += characters.charAt(Math.floor(Math.random() * charactersLength))
  }

  return result1
}

export const formatCompetence = (competence, type) => {
  const competenceMonth = String(competence).slice(-2)
  const competenceYear = String(competence).slice(0, 4)

  let newYear
  let newMonth

  if (competenceMonth === '01' && type === 'prev') {
    newMonth = '12'
    newYear = Number(competenceYear) - 1
  } else if (competenceMonth === '12' && type === 'next') {
    newMonth = '01'
    newYear = Number(competenceYear) + 1
  } else if (type === 'prev') {
    newMonth = Number(competenceMonth) - 1
    newYear = Number(competenceYear)
  } else if (type === 'next') {
    newMonth = Number(competenceMonth) + 1
    newYear = Number(competenceYear)
  } else if (type === 'current') {
    newMonth = Number(competenceMonth)
    newYear = Number(competenceYear)
  }

  return Object.is(`${newYear}${newMonth}`.length, 6)
    ? Number(`${newYear}${newMonth}`)
    : Number(`${newYear}0${newMonth}`)
}

export function HandleCompetencia(
  competencia: string | number,
  tipo: 'MM/YYYY' | 'YYYYMM' = 'MM/YYYY'
) {
  if (!competencia) return ''
  let retorno = ''

  try {
    if (tipo === 'YYYYMM') {
      //competencia esta como MESANO precisa ficar ANOMES pro backend
      //022022

      retorno =
        competencia.toString().trim().substring(2, 5) +
        competencia.toString().trim().substring(0, 2)
    }

    if (tipo === 'MM/YYYY') {
      //competencia esta como ANOMES precisa ficar MESANO pro front
      //202202
      retorno =
        competencia.toString().trim().substring(4, 6) +
        '/' +
        competencia.toString().trim().substring(0, 4)
    }
  } catch (error: any) {
    retorno = ''
  }
  return retorno
}

export function isEqual(val1: any, val2: any): boolean {
  return JSON.stringify(val1) === JSON.stringify(val2)
}

const isPropValuesEqual = <T>(
  subject: T,
  target: T,
  propNames: (keyof T)[]
) => {
  return propNames.every(
    (propName: any) => subject[propName] === target[propName]
  )
}

// Remove os items duplicados de um array de objetos.
const getUniqueItemsByProperties = <T>(
  items: T[],
  propNames: (keyof T)[]
): T[] => {
  return items.filter(
    (item: T, index: number, array: T[]) =>
      index ===
      array.findIndex((foundItem) =>
        isPropValuesEqual<T>(foundItem, item, propNames)
      )
  )
}

const haveDuplicatedItems = <T>(items: T[], propName: keyof T) =>
  items
    .map((item) => item[propName])
    .filter((item, index, vIds) => vIds.indexOf(item) !== index).length > 0

const turnOffHourMinuteSecond = (date: string): string => {
  return moment(new Date(moment(date).toDate()).setUTCHours(0, 0, 0, 0)).toISOString()
}

const downloadLocalPdf = (docName: string) => {
  fetch(docName).then(response => {
    response.blob().then(blob => {
      // Creating new object of PDF file
      const fileURL = window.URL.createObjectURL(blob);
      // Setting various property values
      const alink = document.createElement('a');
      alink.href = fileURL;
      alink.download = docName;
      alink.click();
    })
  })
}

export default {
  turnOffHourMinuteSecond,
  haveDuplicatedItems,
  getUniqueItemsByProperties,
  filterObject,
  isEqual,
  expandObj,
  downloadLocalPdf,
}
